document.addEventListener("DOMContentLoaded", () => {
  initProductCardSliders();
  scrollToProductSizes(); 
  initReadMore();
  initSubmenuFilters();
  initSubCollectionsFilters();
  initGridSlider();

  window.addEventListener("klaviyoForms", function(e) {
    const { type, formId } = e.detail;

    const targetFormIds = ["WjbUT8", "XLvwXF", "Vp5AZ6"];
    if (type === "embedOpen" && targetFormIds.includes(formId)) {
      onKlaviyoFormOpen(formId);
    }
  });

  // Traducir pop-up de Klaviyo (solo si está en español o italiano)
  if (isPortugueseLanguage() || isItalianLanguage() || isDeutschLanguage()) {
    translateKlaviyoPopup();
    // Traducir botón "NOTIFY ME WHEN AVAILABLE"
    translateNotifyButton();
  }
});

document.addEventListener("wim-product-recommendations:loaded", () => {
  initProductCardSliders();
});

function initProductCardSliders() {
  document.querySelectorAll("[data-slider]:not(.is-started)").forEach((slider) => {
    slider.classList.add("is-started");
    const image = slider.querySelector(".product-card__image");
    if (!image) return;
    const images = JSON.parse(slider.dataset.images);
    if (images.length <= 1) return;
    let current = 0;
    const prev = slider.querySelector(".prev");
    const next = slider.querySelector(".next");

    function showSlide(index) {
      current = index;
      image.removeAttribute("srcset");
      image.removeAttribute("sizes");
      image.src = images[current];

      const nextIndex = (current + 1) % images.length;
      const preload = new Image();
      preload.src = images[nextIndex];
    }

    prev.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      showSlide((current - 1 + images.length) % images.length);
    });

    next.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      showSlide((current + 1) % images.length);
    });

    let touchStartX = 0;
    let touchEndX = 0;

    slider.addEventListener("touchstart", (e) => {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });

    slider.addEventListener("touchend", (e) => {
      touchEndX = e.changedTouches[0].clientX;

      const diff = touchStartX - touchEndX;
      if (Math.abs(diff) < 50) return;

      if (diff > 0) {
        showSlide((current + 1) % images.length);
      } else {
        showSlide((current - 1 + images.length) % images.length);
      }
    }, { passive: true });

  });
}

window.initProductCardSliders = initProductCardSliders;

(function () {
  if (window.customElements.get("collection-infinite-scroll")) return;

class CollectionInfiniteScroll extends HTMLElement {
  connectedCallback() {
    this.querySelector("nav.pagination")?.setAttribute("hidden", "");

    if (!this.hasAttribute("next-url")) return;

    this.observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) this.loadNextPage();
    }, { rootMargin: "0px 0px 600px 0px" });

    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  async loadNextPage() {
    if (this.loading) return;
    this.loading = true;
    this.observer.unobserve(this);

    const sectionId = this.getAttribute("section-id");
    const url = new URL(this.getAttribute("next-url"), window.location.origin);
    url.searchParams.set("section_id", sectionId);

    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));

    try {
      const response = await fetch(url.toString());
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, "text/html");

      const liveGrid = this.closest(".shopify-section")?.querySelector("product-list");
      const newGrid = parsed.querySelector("product-list");
      const newCards = newGrid ? [...newGrid.querySelectorAll(":scope > product-card")] : [];

      if (liveGrid) {
        newCards.forEach((card) => liveGrid.appendChild(document.importNode(card, true)));
      }

      const newInfiniteScroll = parsed.querySelector("collection-infinite-scroll");
      const nextUrl = newInfiniteScroll?.getAttribute("next-url");

      if (nextUrl) {
        this.setAttribute("next-url", nextUrl);
        this.observer.observe(this);
      } else {
        this.removeAttribute("next-url");
      }

      initProductCardSliders();

      document.dispatchEvent(new CustomEvent("wim-infinite-scroll:products-loaded", {
        bubbles: true,
        detail: { sectionId, url: url.toString(), addedCount: newCards.length, products: newCards },
      }));
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
      this.loading = false;
    }
  }
}

  window.customElements.define("collection-infinite-scroll", CollectionInfiniteScroll);
})();

function scrollToProductSizes() {
  document.querySelectorAll('product-sticky-add-to-cart').forEach((container) => {
    container.addEventListener('click', (event) => {
      const button = event.target.closest('.sticky-scroll-button');
      if (!button) return;

      const target = document.querySelector('.product-title.h4');
      if (!target) return;

      const headerOffset = 77;
      const offsetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;

      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    });
  });
}

function initReadMore() {
  document.querySelectorAll('.richtext-toggle').forEach((button) => {
    button.addEventListener('click', function () {
      const wrapper = this.closest('.richtext-wrapper');
      const expanded = wrapper.classList.toggle('is-expanded');

      this.textContent = expanded
        ? this.dataset.readLess
        : this.dataset.readMore;
    });
  });
}

function getCurrentLanguage() {
  const lang = document.documentElement.lang || document.documentElement.getAttribute('lang') || '';
  return lang.toLowerCase();
} 

function isPortugueseLanguage() {
  const lang = getCurrentLanguage();
  return lang.startsWith('pt');
}

function isItalianLanguage() {
  const lang = getCurrentLanguage();
  return lang.startsWith('it');
}

function isDeutschLanguage() {
  const lang = getCurrentLanguage();
  return lang.startsWith('de');
}

function needsTranslation() {
  return isPortugueseLanguage() || isItalianLanguage() || isDeutschLanguage();
}

function translateKlaviyoPopup() {
  // Traducciones por idioma
  const translations = {
    pt: {
      "LET ME KNOW IF IT BECOMES AVAILABLE AGAIN": "AVISE-ME QUANDO ESTE TAMANHO ESTIVER DISPONÍVEL",
      "We’ll send you an email if that size becomes available again. All you need to do is enter your details.": "Enviaremos um e-mail quando esse tamanho estiver disponível novamente. Tudo o que precisa fazer é digitar seus dados.",
      "Enter your email": "Insira seu email",
      "Also receive promotional marketing emails.": "Desejo receber também emails promocionais.",
      "LET ME KNOW WHEN IT’S AVAILABLE!": "AVISE-ME QUANDO ESTIVER DISPONÍVEL!",
      "*By requesting an availability alert, you confirm that you have read and accepted our Privacy Policy, which is available in the footer of this website.": "*Ao solicitar um aviso de disponibilidade, você confirma que leu e aceitou a nossa Política de Privacidade, disponível no rodapé do site.",
      "THAT'S IT! ALERT CREATED": "PRONTO! AVISO CRIADO",
      "Keep an eye on your inbox in case it becomes available again soon.": "Fique atento à sua caixa de entrada, pode estar disponível em breve.",
      "CONTINUE SHOPPING": "CONTINUAR COMPRANDO"
    },
    it: {
      "LET ME KNOW IF IT BECOMES AVAILABLE AGAIN": "FAMMI SAPERE QUANDO TORNA DISPONIBILE",
      "We’ll send you an email if that size becomes available again. All you need to do is enter your details.": "Ti invieremo un'email quando questo modello tornerà disponibile. Tutto quello che devi fare è inserire i tuoi dati.",
      "Enter your email": "Inserisci la tua email",
      "Also receive promotional marketing emails.": "Desidero ricevere anche offerte e novità.",
      "LET ME KNOW WHEN IT’S AVAILABLE!": "AVVISAMI QUANDO DISPONIBILE!",
      "*By requesting an availability alert, you confirm that you have read and accepted our Privacy Policy, which is available in the footer of this website.": "*Richiedendo un avviso di disponibilità, confermi di aver letto e accettato la nostra Informativa sulla privacy, disponibile nel footer del sito.",
      "THAT'S IT! ALERT CREATED": "PERFETTO! AVVISO CREATO",
      "Keep an eye on your inbox in case it becomes available again soon.": "Tieni d'occhio la tua casella email, potremmo averlo di nuovo a breve.",
      "CONTINUE SHOPPING": "CONTINUA SHOPPING"
    },
    de: {
      "LET ME KNOW IF IT BECOMES AVAILABLE AGAIN": "SAGEN SIE MIR BESCHEID, WENN ES WIEDER VERFÜGBAR IST",
      "We’ll send you an email if that size becomes available again. All you need to do is enter your details.": "Wir schicken Ihnen eine E-Mail, wenn diese Größe wieder verfügbar ist. Sie müssen nur Ihre Daten eingeben.",
      "Enter your email": "E-Mail-Adresse eingeben",
      "Also receive promotional marketing emails.": "Ich möchte auch Werbe-E-Mails erhalten.",
      "LET ME KNOW WHEN IT’S AVAILABLE!": "BENACHRICHTIGE MICH, WENN VERFÜGBAR!",
      "*By requesting an availability alert, you confirm that you have read and accepted our Privacy Policy, which is available in the footer of this website.": "*Durch die Anforderung einer Verfügbarkeitsmitteilung bestätigen Sie, dass Sie unsere Datenschutzrichtlinie gelesen und akzeptiert haben, die Sie in der Fußzeile dieser Website finden.",
      "THAT'S IT! ALERT CREATED": "FERTIG! BENACHRICHTIGUNG ERSTELLT",
      "Keep an eye on your inbox in case it becomes available again soon.": "Schauen Sie in Ihr Posteingang – es könnte bald wieder verfügbar sein.",
      "CONTINUE SHOPPING": "WEITER EINKAUFEN"
    }
  };

  // Obtener el idioma actual
  const currentLang = isPortugueseLanguage() ? 'pt' : isItalianLanguage() ? 'it' : isDeutschLanguage() ? 'de' : null;
  if (!currentLang) return;

  const langTranslations = translations[currentLang];

  // Función para traducir los textos del pop-up
  function translatePopupTexts(popupElement) {
    if (!popupElement || !needsTranslation()) return;

    // Traducir placeholder del email
    const emailInput = popupElement.querySelector('input[type="email"]');
    if (emailInput && emailInput.placeholder === "Enter your email") {
      emailInput.placeholder = langTranslations["Enter your email"];
    }

    // Traducir texto del checkbox
    const checkboxLabel = popupElement.querySelector('label[for^="opt_in_promotional_email"]');
    if (checkboxLabel) {
      const labelText = checkboxLabel.querySelector('div');
      if (labelText && labelText.textContent.trim() === "Also receive promotional marketing emails.") {
        labelText.textContent = langTranslations["Also receive promotional marketing emails."];
      }
    }

    // Traducir todos los botones
    const buttons = popupElement.querySelectorAll('button[type="button"]');
    buttons.forEach(function(button) {
      const buttonText = button.textContent.trim();
      if (buttonText === "LET ME KNOW WHEN IT’S AVAILABLE!") {
        button.textContent = langTranslations["LET ME KNOW WHEN IT’S AVAILABLE!"];
      } else if (buttonText === "CONTINUE SHOPPING") {
        button.textContent = langTranslations["CONTINUE SHOPPING"];
      }
    });

    // Traducir todos los títulos h1
    const titleElements = popupElement.querySelectorAll('h1 span');
    titleElements.forEach(function(titleElement) {
      const titleText = titleElement.textContent.trim();
      if ( titleText === "LET ME KNOW IF IT BECOMES AVAILABLE AGAIN") {
        titleElement.textContent = langTranslations["LET ME KNOW IF IT BECOMES AVAILABLE AGAIN"];
      } else if (titleText === "THAT'S IT! ALERT CREATED") {
        titleElement.textContent = langTranslations["THAT'S IT! ALERT CREATED"];
      }
    });

    // Traducir todos los párrafos
    const paragraphElements = popupElement.querySelectorAll('div');
    paragraphElements.forEach(function(paragraphElement) {
      const paragraphText = paragraphElement.textContent.trim();
      if (paragraphText === "We’ll send you an email if that size becomes available again. All you need to do is enter your details.") {
        paragraphElement.textContent = langTranslations["We’ll send you an email if that size becomes available again. All you need to do is enter your details."];
        paragraphElement.style.display = "flex";
        paragraphElement.style.flexDirection = "column";
        paragraphElement.style.padding = "8px 0px 25px";
        paragraphElement.style.justifyContent = "center";
        paragraphElement.style.alignItems = "center";
        paragraphElement.style.textAlign = "center";
        paragraphElement.style.fontSize = "14px";
        paragraphElement.style.margin = "0 3px";
      } else if (paragraphText === "Keep an eye on your inbox in case it becomes available again soon.") {
        paragraphElement.textContent = langTranslations["Keep an eye on your inbox in case it becomes available again soon."];
        paragraphElement.style.flexDirection = "column";
        paragraphElement.style.padding = "8px 0px 13px";
        paragraphElement.style.justifyContent = "center";
        paragraphElement.style.alignItems = "center";
        paragraphElement.style.textAlign = "center";
        paragraphElement.style.fontSize = "14px";
        paragraphElement.style.margin = "0 3px";
      }
    });

    //Traducir condiciones
    const conditionElements = popupElement.querySelectorAll('div span');
    conditionElements.forEach(function(conditionElement) {
      const conditionText = conditionElement.textContent.trim();
      if ( conditionText === "*By requesting an availability alert, you confirm that you have read and accepted our Privacy Policy, which is available in the footer of this website.") {
        conditionElement.textContent = langTranslations["*By requesting an availability alert, you confirm that you have read and accepted our Privacy Policy, which is available in the footer of this website."];
      }
    });
    
  }

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          // Buscar el pop-up de Klaviyo
          const popup = node.querySelector && node.querySelector('[role="dialog"][aria-label="POPUP Form"]');
          if (popup) {
            // Esperar un momento para que el contenido se renderice completamente
            setTimeout(() => {
              translatePopupTexts(popup);
            }, 100);
          }
          
          // También verificar si el nodo agregado es el pop-up mismo
          if (node.getAttribute && node.getAttribute('role') === 'dialog' && node.getAttribute('aria-label') === 'POPUP Form') {
            setTimeout(() => {
              translatePopupTexts(node);
            }, 100);
          }
        }
      });

      // Observar cambios en el contenido del formulario (cuando cambia a pantalla de confirmación)
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        const popup = document.querySelector('[role="dialog"][aria-label="POPUP Form"]');
        if (popup) {
          setTimeout(() => {
            translatePopupTexts(popup);
          }, 100);
        }
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  setTimeout(() => {
    const existingPopup = document.querySelector('[role="dialog"][aria-label="POPUP Form"]');
    if (existingPopup) {
      translatePopupTexts(existingPopup);
    }
  }, 500);

  // Escuchar eventos de Klaviyo para detectar cuando se abre el pop-up o cambia el contenido
  window.addEventListener("klaviyoForms", function(e) {
    const { type } = e.detail;
    if (type === "embedOpen" || type === "open" || type === "submit" || type === "success") {
      setTimeout(() => {
        const popup = document.querySelector('[role="dialog"][aria-label="POPUP Form"]');
        if (popup) {
          translatePopupTexts(popup);
        }
      }, 300);
    }
  });

  const formObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        const klaviyoForm = document.querySelector('form[data-testid^="klaviyo-form-"]');
        if (klaviyoForm) {
          const popup = klaviyoForm.closest('[role="dialog"]');
          if (popup) {
            setTimeout(() => {
              translatePopupTexts(popup);
            }, 100);
          }
        }
      }
    });
  });

  
  const checkAndObserveForms = function() {
    const klaviyoForms = document.querySelectorAll('form[data-testid^="klaviyo-form-"]');
    klaviyoForms.forEach(function(form) {
      formObserver.observe(form, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });
  };

  // Verificar formularios periódicamente
  setInterval(checkAndObserveForms, 1000);
  checkAndObserveForms();
}

function translateNotifyButton() {
  if (!needsTranslation()) return;
  
  const buttonTranslations = {
    pt: "AVISE-ME QUANDO ESTIVER DISPONÍVEL",
    it: "AVVISAMI QUANDO TORNA DISPONIBILE",
    de: "BENACHRICHTIGE MICH, WENN VERFÜGBAR"
  };
  
  const currentLang = isPortugueseLanguage() ? 'pt' : isItalianLanguage() ? 'it' : isDeutschLanguage() ? 'de' : null;
  if (!currentLang) return;
  
  const translatedText = buttonTranslations[currentLang];
  
  function translateButton() {
    if (!needsTranslation()) return;
    const buttons = document.querySelectorAll('button[data-a11y-identifier^="bis-button"]');
    buttons.forEach(function(button) {
      if (button.textContent.trim() === "NOTIFY ME WHEN BACK IN STOCK") {
        button.textContent = translatedText;
      }
    });
    
    const allButtons = document.querySelectorAll('button');
    allButtons.forEach(function(button) {
      if (button.textContent.trim() === "NOTIFY ME WHEN BACK IN STOCK") {
        button.textContent = translatedText;
      }
    });
  }

  translateButton();

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (!needsTranslation()) return;
        if (node.nodeType === 1) { // Element node
          // Verificar si el nodo es el botón o contiene el botón
          if (node.tagName === 'BUTTON' && node.textContent && node.textContent.trim() === "NOTIFY ME WHEN BACK IN STOCK") {
            node.textContent = translatedText;
          } else if (node.querySelector) {
            const button = node.querySelector('button[data-a11y-identifier^="bis-button"]');
            if (button && button.textContent.trim() === "NOTIFY ME WHEN BACK IN STOCK") {
              button.textContent = translatedText;
            }
          }
        }
      });
    });
    
    translateButton();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  setInterval(translateButton, 1000);
}
function initSubmenuFilters() {
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.wim-custom-filter');

    if (!button) return;

    event.preventDefault();

    if (button.classList.contains('wim-custom-filter--all')) {
      document
        .querySelector('button[type="reset"][form="facets-drawer-form"]')
        ?.click();

      return;
    }

    const input = document.querySelector(
      `input[name="${button.dataset.filterName}"][value="${button.dataset.filterValue}"]`
    );

    if (!input) return;

    document
      .querySelectorAll(
        `#facets-drawer-form input[name="${button.dataset.filterName}"]:checked`
      )
      .forEach((checkedInput) => {
        if (checkedInput !== input) {
          checkedInput.click();
        }
      });

    if (!input.checked) {
      input.click();
    }

    setTimeout(() => {
      document
        .querySelector('button[type="submit"][form="facets-drawer-form"]')
        ?.click();
    }, 100);
  });
}

function initGridSlider() {
  document.querySelectorAll('.grid--slider').forEach((slider) => {
    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;
    let moved = false;

    slider.addEventListener('mousedown', (e) => {
      if (e.button !== 0) return;
      isDown = true;
      moved = false;
      startX = e.clientX;
      startScrollLeft = slider.scrollLeft;
      slider.classList.add('is-dragging');
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      const distance = e.clientX - startX;
      if (Math.abs(distance) > 5) {
        moved = true;
      }
      if (moved) {
        slider.scrollLeft = startScrollLeft - distance;
      }
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('is-dragging');
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('is-dragging');
    });

    slider.addEventListener('click', (e) => {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }, true);
  });
}

function initSubCollectionsFilters() {
  document.addEventListener('click', function (event) {
    const button = event.target.closest('.wim-subfilters');
    if (!button) return;
    event.preventDefault();
    const filterName = button.dataset.filterName?.trim();
    const filterValues = button.dataset.filterValues
      ?.split(',')
      .map(value => value.trim())
      .filter(Boolean);
    if (!filterName || !filterValues?.length) return;
    const filterGroup = [...document.querySelectorAll('accordion-disclosure')]
      .find(el =>
        el.querySelector('summary')?.textContent.trim().toLowerCase() === filterName.toLowerCase()
      );
    if (!filterGroup) return;

    const checkboxes = filterValues.map(value => {
      return [...filterGroup.querySelectorAll('input[type="checkbox"]')]
        .find(input =>
          input.value.trim().toLowerCase() === value.toLowerCase()
        );
    }).filter(Boolean);

    checkboxes.forEach(checkbox => {
      if (!checkbox.checked) {
        checkbox.click();
      }
    });

    const allChecked = checkboxes.every(checkbox => checkbox.checked);
    button.classList.toggle('checked', allChecked);
    if (allChecked) {
      document
        .querySelector('button[type="submit"][form="facets-drawer-form"]')
        ?.click();
    }
  });
}
// FIX BUNDLER SHOP BUTTON
(function () {
  const BUNDLER_SELECTOR = '[class*="bndlr"], [id*="bndlr"], [class*="bundler"], [id*="bundler"]';

  const isBundlerTarget = (target) =>
    target instanceof Element && target.closest(BUNDLER_SELECTOR) !== null;

  customElements.whenDefined("cart-drawer").then(() => {
    const proto = customElements.get("cart-drawer").prototype;
    const originalHide = proto.hideForOutsideClickTarget;
    const originalAllow = proto.allowOutsideClickForTarget;

    proto.hideForOutsideClickTarget = function (target) {
      if (isBundlerTarget(target)) return false;
      return originalHide.call(this, target);
    };

    proto.allowOutsideClickForTarget = function (target) {
      if (isBundlerTarget(target)) return true;
      return originalAllow.call(this, target);
    };
  });
})();

window.addEventListener("click", (event) => {
  if (event.isTrusted) return;

  const activator = event.target instanceof Element && event.target.closest('[aria-controls="cart-drawer"]');
  const cartDrawer = document.getElementById("cart-drawer");
  if (!activator || !cartDrawer?.open) return;

  event.preventDefault();
  event.stopImmediatePropagation();
  document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
}, true);

/* F4 · Talla sin preseleccionar en la ficha.
   Al entrar sin ?variant= en la URL, se desmarca la talla, el botón dice «Selecciona una talla»
   y no se puede añadir hasta elegir una. Al elegir, el theme vuelve a pintar la ficha con la talla elegida. */
(function () {
  const picked = new Set();

  function sizeFieldset(picker) {
    const marked = picker.querySelector("fieldset[data-wim-size]");
    if (marked) return marked;
    const all = picker.querySelectorAll("fieldset.variant-picker__option");
    return all.length === 1 ? all[0] : null;
  }

  function submitButtons(formId) {
    const form = document.getElementById(formId);
    const inForm = form ? Array.from(form.querySelectorAll('button[type="submit"]')) : [];
    const sticky = Array.from(document.querySelectorAll("product-sticky-add-to-cart .sticky-scroll-button"));
    return inForm.concat(sticky);
  }

  function apply(picker) {
    const formId = picker.getAttribute("form-id");
    const label = picker.dataset.wimSelectSize;
    if (!formId || !label || picked.has(formId)) return;
    if (new URLSearchParams(window.location.search).has("variant")) return;
    const fs = sizeFieldset(picker);
    if (!fs) return;
    const radios = fs.querySelectorAll('input[type="radio"]');
    if (radios.length < 2) return;

    radios.forEach((r) => (r.checked = false));
    const current = fs.querySelector(".variant-picker__option-info span");
    if (current) current.textContent = "—";
    fs.classList.add("wim-size-pending");

    submitButtons(formId).forEach((btn) => {
      if (!btn.dataset.wimLabel) btn.dataset.wimLabel = btn.innerHTML;
      const text = btn.querySelector("button-content") || btn;
      text.textContent = label;
      ["rotated-text", "up-text"].forEach((a) => text.hasAttribute && text.hasAttribute(a) && text.setAttribute(a, label));
      btn.classList.add("wim-size-needed");
    });
    document.documentElement.dataset.wimSizePending = formId;
  }

  function release(formId) {
    picked.add(formId);
    if (document.documentElement.dataset.wimSizePending === formId) delete document.documentElement.dataset.wimSizePending;
    submitButtons(formId).forEach((btn) => {
      if (btn.dataset.wimLabel) btn.innerHTML = btn.dataset.wimLabel;
      btn.classList.remove("wim-size-needed");
      delete btn.dataset.wimLabel;
    });
    document.querySelectorAll(".wim-size-pending").forEach((fs) => fs.classList.remove("wim-size-pending", "wim-size-error"));
  }

  function pendingFor(target) {
    const formId = document.documentElement.dataset.wimSizePending;
    if (!formId) return null;
    const btn = target.closest('button[type="submit"]');
    if (!btn) return null;
    // form.id no sirve: el input name="id" del formulario lo tapa
    const owner = btn.getAttribute("form") || (btn.form && btn.form.getAttribute("id"));
    const inForm = owner === formId;
    return inForm ? formId : null;
  }

  document.addEventListener("change", (e) => {
    const picker = e.target.closest("variant-picker[data-wim-select-size]");
    if (picker && e.target.matches('input[type="radio"]')) release(picker.getAttribute("form-id"));
  }, true);

  document.addEventListener("click", (e) => {
    const formId = pendingFor(e.target);
    if (!formId) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    const picker = document.querySelector(`variant-picker[form-id="${formId}"]`);
    const fs = picker && sizeFieldset(picker);
    if (fs) {
      fs.classList.add("wim-size-error");
      fs.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, true);

  function init() {
    document.querySelectorAll("variant-picker[data-wim-select-size]").forEach(apply);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();

/* E1/K1 · Fecha estimada de entrega: hoy + N días laborables (lunes a viernes), en el idioma de la tienda. */
(function () {
  function addWorkingDays(days) {
    const d = new Date();
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      const w = d.getDay();
      if (w !== 0 && w !== 6) added++;
    }
    return d;
  }
  function fill(root) {
    (root || document).querySelectorAll("[data-wim-eta]:not([data-wim-eta-done])").forEach((el) => {
      const tpl = el.getAttribute("data-wim-eta");
      const min = parseInt(el.getAttribute("data-wim-eta-min"), 10) || 5;
      const max = parseInt(el.getAttribute("data-wim-eta-max"), 10) || 11;
      try {
        const lang = document.documentElement.lang || "en";
        const fmt = new Intl.DateTimeFormat(lang, { day: "numeric", month: "long" });
        el.textContent = tpl.replace("__FROM__", fmt.format(addWorkingDays(min))).replace("__TO__", fmt.format(addWorkingDays(max)));
      } catch (e) { /* se queda el texto de plazo en días */ }
      el.setAttribute("data-wim-eta-done", "");
    });
  }
  const start = () => {
    fill();
    new MutationObserver(() => fill()).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();

/* F2 · Barra de compra fija: visible también al entrar, mientras el botón principal no se ve en pantalla
   (el theme solo la enseña cuando se ha pasado el formulario entero). */
(function () {
  function init() {
    const sticky = document.querySelector("product-sticky-add-to-cart");
    if (!sticky || !("IntersectionObserver" in window)) return;
    const formId = sticky.getAttribute("main-product-form");
    const form = formId && document.getElementById(formId);
    const mainBtn = form && form.querySelector('button[type="submit"]');
    const footer = document.querySelector(".shopify-section--footer");
    if (!mainBtn) return;
    let btnVisible = true, footerVisible = false;
    const update = () => sticky.toggleAttribute("data-wim-show", !btnVisible && !footerVisible);
    new IntersectionObserver((es) => es.forEach((e) => {
      if (e.target === mainBtn) btnVisible = e.isIntersecting;
      if (e.target === footer) footerVisible = e.isIntersecting;
      update();
    })).observe(mainBtn);
    if (footer) new IntersectionObserver((es) => es.forEach((e) => { footerVisible = e.isIntersecting; update(); })).observe(footer);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();

/* W5 · Selector de país: la lista se pinta al abrirlo (ver snippets/localization-selector.liquid) */
(function () {
  function fill(popover) {
    if (!popover) return;
    popover.querySelectorAll("template[data-wim-lazy-countries]").forEach(function (tpl) {
      tpl.replaceWith(tpl.content.cloneNode(true));
    });
  }
  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest('[aria-controls^="popover-localization-"]');
    if (btn) fill(document.getElementById(btn.getAttribute("aria-controls")));
  }, true);
})();

/* F6 · Aviso de reposición (snippets/wim-back-in-stock.liquid): alta en Klaviyo con su API pública */
document.addEventListener("submit", function (e) {
  var form = e.target.closest && e.target.closest(".wim-bis__form");
  if (!form) return;
  e.preventDefault();
  var box = form.closest(".wim-bis");
  var msg = box.querySelector(".wim-bis__msg");
  var input = form.querySelector('input[type="email"]');
  var email = (input.value || "").trim();
  function show(ok) {
    msg.hidden = false;
    msg.textContent = ok ? msg.dataset.ok : msg.dataset.error;
    msg.classList.toggle("wim-bis__msg--error", !ok);
    if (ok) form.hidden = true;
  }
  if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { show(false); input.focus(); return; }
  var btn = form.querySelector("button");
  btn.disabled = true;
  fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=" + encodeURIComponent(box.dataset.company), {
    method: "POST",
    headers: { "Content-Type": "application/json", revision: "2024-10-15" },
    body: JSON.stringify({ data: { type: "back-in-stock-subscription", attributes: {
      channels: ["EMAIL"],
      profile: { data: { type: "profile", attributes: { email: email } } }
    }, relationships: { variant: { data: { type: "catalog-variant", id: "$shopify:::$default:::" + box.dataset.variant } } } } })
  }).then(function (r) { show(r.ok); }).catch(function () { show(false); }).finally(function () { btn.disabled = false; });
});

/* N1 · Ruta de navegación de la ficha: recuerda la última colección visitada en esta sesión */
(function () {
  try {
    var m = location.pathname.match(/^(\/[a-z]{2}(-[a-z]{2})?)?\/collections\/[^\/]+\/?$/i);
    if (m) {
      var h1 = document.querySelector("main h1");
      sessionStorage.setItem("wimLastCollection", JSON.stringify({ path: location.pathname, title: (h1 ? h1.textContent : document.title).trim() }));
      return;
    }
    var li = document.querySelector("[data-wim-crumb]");
    if (!li) return;
    var last = JSON.parse(sessionStorage.getItem("wimLastCollection") || "null");
    if (!last || !last.path || !last.title) return;
    var a = li.querySelector("a");
    a.href = last.path;
    a.textContent = last.title;
    li.hidden = false;
  } catch (e) {}
})();

/* F6 · Mostrar el aviso de reposición solo cuando la talla elegida está agotada */
(function () {
  function sync() {
    document.querySelectorAll(".wim-bis[data-unavailable]").forEach(function (box) {
      var form = box.parentElement && box.parentElement.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      var input = form && form.querySelector('input[name="id"]');
      var params = new URLSearchParams(location.search);
      var id = (input && input.value) || params.get("variant") || "";
      var list = box.dataset.unavailable.split(",");
      var show = id && list.indexOf(String(id)) > -1;
      if (show && box.dataset.variant !== id) {
        box.dataset.variant = id;
        var f = box.querySelector(".wim-bis__form"), m = box.querySelector(".wim-bis__msg");
        if (f) f.hidden = false;
        if (m) m.hidden = true;
      }
      box.hidden = !show;
    });
  }
  document.addEventListener("change", function (e) {
    if (e.target.closest && e.target.closest("variant-picker")) setTimeout(sync, 400);
  });
  if (document.readyState !== "loading") sync(); else document.addEventListener("DOMContentLoaded", sync);
})();
